import { Text } from '@podiumhq/design-system';

import { YEARLY_TERM } from 'components/PricingPackaging/constants';
import { useCheckoutContext } from 'contexts/CheckoutContextProvider';

import { confirmDetailsTextStyles } from '../styles';

import { ConfirmDetailsSectionWrapper } from './ConfirmDetailsSectionWrapper';

const SelectPlanTerm = (props) => {
  const { selectedPlan, selectedTerm } = useCheckoutContext();
  const { displayName = '' } = selectedPlan || {};
  const isAnnual = selectedTerm === YEARLY_TERM;
  const termAgreement = isAnnual
    ? '12 month agreement'
    : 'Month-to-month agreement';

  return (
    <ConfirmDetailsSectionWrapper
      displayDivider
      id="fs-plan-type-change"
      title="Plan Type"
      {...props}
    >
      <Text {...confirmDetailsTextStyles}>{displayName}</Text>
      <Text {...confirmDetailsTextStyles}>{termAgreement}</Text>
    </ConfirmDetailsSectionWrapper>
  );
};

export default SelectPlanTerm;
